// components/feedback/Toast.jsx
import React from 'react'
import { Toaster, toast } from 'sonner'
import tokens from '../../lib/design-tokens'

export function ToastProvider() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 4000,
        style: {
          background: 'white',
          border: '1px solid rgb(226 232 240)',
          borderRadius: tokens.radius.lg,
          boxShadow: tokens.shadow.lg,
          padding: '12px 16px',
        },
      }}
    />
  )
}

/**
 * Toast avec action Undo
 */
export function toastWithUndo(message, onUndo, options = {}) {
  return toast(message, {
    action: {
      label: 'Annuler',
      onClick: onUndo,
    },
    ...options,
  })
}

/**
 * Toast de succès
 */
export function toastSuccess(message, description) {
  return toast.success(message, {
    description,
  })
}

/**
 * Toast d'erreur
 */
export function toastError(message, description) {
  return toast.error(message, {
    description,
  })
}

/**
 * Toast avec promesse (loading → success/error)
 */
export function toastPromise(promise, messages) {
  return toast.promise(promise, {
    loading: messages.loading || 'Chargement...',
    success: messages.success || 'Succès !',
    error: messages.error || 'Erreur',
  })
}

// Export sonner pour usage direct
export { toast }
